const _excluded = ["className", "onChange", "options", "disabled", "disabledText", "valueKey", "values"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * @class MultiPicker
 *
 */
import { has, isArray, isObject, pluck } from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import Select from './select';
const MultiPicker = _ref => {
  let {
      className = '',
      onChange,
      options = [],
      disabled = false,
      disabledText = '',
      valueKey = 'id',
      values = []
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  /**
   *  @function handleChange - strip className attribute from changed values
   */
  const handleChange = incomingValues => {
    const handleChangeValues = (incomingValues || []).map(val => {
      const result = JSON.parse(JSON.stringify(val));
      if (has(result, 'className')) {
        delete result.className;
      }
      return result;
    });
    onChange(handleChangeValues);
  };

  /**
  * @function prepareValues  - prepare a list of single primitive values, e.g. ID strings
  */
  const prepareValues = () => {
    let result = values;
    if (isArray(values)) {
      if (values.length > 0 && isObject(values[0])) {
        result = pluck(values, valueKey);
      }
    }
    return result;
  };
  const selectProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    values: prepareValues(),
    multi: true,
    onChange: handleChange,
    className: `${className} t-sp`,
    options,
    disabled,
    disabledText,
    valueKey
  });
  return /*#__PURE__*/React.createElement(Select, selectProps);
};
MultiPicker.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  valueKey: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object]))
};
export default MultiPicker;